import { siteInfo } from '@/mocks/site';
import Hero from './components/Hero';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import LatestArticles from './components/LatestArticles';
import CommunityHighlights from './components/CommunityHighlights';
import FAQ from './components/FAQ';
import CTA from './components/CTA';

export default function Home() {
  const schemaData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': `${siteInfo.url}/#organization`,
        name: siteInfo.name,
        url: siteInfo.url,
        description: siteInfo.description,
        email: siteInfo.email,
        telephone: siteInfo.phone,
        address: {
          '@type': 'PostalAddress',
          streetAddress: '张江高科技园区动漫产业园 A 座 12 层',
          addressLocality: '上海',
          addressRegion: '浦东新区',
          addressCountry: 'CN',
        },
      },
      {
        '@type': 'WebSite',
        '@id': `${siteInfo.url}/#website`,
        name: siteInfo.name,
        url: siteInfo.url,
        description: siteInfo.description,
        potentialAction: {
          '@type': 'SearchAction',
          'target': `${siteInfo.url}/search?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        '@id': `${siteInfo.url}/#webpage`,
        url: siteInfo.url,
        name: '萝幼社 - 官方正版授权二次元内容平台',
        description: siteInfo.description,
        isPartOf: { '@id': `${siteInfo.url}/#website` },
        about: { '@id': `${siteInfo.url}/#organization` },
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '萝幼社是什么？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '萝幼社是一个专注于二次元文化的正版授权内容平台，汇聚海量优质创作资源，为广大二次元爱好者提供丰富的视觉内容与社区互动体验。',
            },
          },
          {
            '@type': 'Question',
            name: '如何成为萝幼社的创作者？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '通过官网加入我们页面提交申请，上传代表作品，审核团队在3-5个工作日内完成审核。',
            },
          },
          {
            '@type': 'Question',
            name: '萝幼社的内容都是正版授权的吗？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '是的，萝幼社始终坚持正版授权原则。平台上的所有原创内容均获得创作者的正版授权。',
            },
          },
        ],
      },
    ],
  };

  return (
    <>
      <title>萝幼社 - 官方正版授权二次元内容平台</title>
      <meta name="description" content={siteInfo.description} />
      <meta name="keywords" content="萝幼社,萝幼社官网,萝幼社正版,二次元内容平台,萝幼社会员,二次元社区,萝幼社资源" />
      <link rel="canonical" href={siteInfo.url} />
      <meta property="og:title" content="萝幼社 - 官方正版授权二次元内容平台" />
      <meta property="og:description" content={siteInfo.description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={siteInfo.url} />
      <meta property="og:locale" content="zh_CN" />
      <meta property="og:site_name" content={siteInfo.name} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="萝幼社 - 官方正版授权二次元内容平台" />
      <meta name="twitter:description" content={siteInfo.description} />
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>

      <main>
        <Hero />
        <CategoryNav />
        <FeaturedArticles />
        <LatestArticles />
        <CommunityHighlights />
        <FAQ />
        <CTA />
      </main>
    </>
  );
}